import { render, staticRenderFns } from "./scanTheCode.vue?vue&type=template&id=2247f352"
import script from "./scanTheCode.vue?vue&type=script&lang=js"
export * from "./scanTheCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports